import { colors } from 'styles/colors';
import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  root: {
    background: colors.neutralVeryLight,
  },
});
